import { render, staticRenderFns } from "./ExportCitationsOptions.vue?vue&type=template&id=fd564fe0&scoped=true&"
import script from "./ExportCitationsOptions.vue?vue&type=script&lang=js&"
export * from "./ExportCitationsOptions.vue?vue&type=script&lang=js&"
import style0 from "./ExportCitationsOptions.vue?vue&type=style&index=0&id=fd564fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd564fe0",
  null
  
)

export default component.exports